module.exports = __webpack_public_path__ + "static/media/digital.cca89713.png";